const productsData = window.reviewsPage.products

const SELECTORS = {
  YOTPO_WIDGET: '.yotpo-reviews-seo-page',
  REVIEW: '.yotpo-review',
  CENTER_PANEL: '.yotpo-review-center-panel',
  LEFT_PANEL: '.yotpo-review-left-panel',
  PRODUCT_LINK: '.yotpo-text-link-name',
  DROPDOWN_OPTIONS: '.yotpo-dropdown-option',
  PAGINATION_ITEM: '.yotpo-reviews-seo-pagination-item',
  LOADING_PLACEHOLDER: '.yotpo-seo-reviews-placeholder'
}

const addProductImages = () => {
  const reviewEls = document.querySelectorAll(SELECTORS.REVIEW)
  const widgetEl = document.querySelector(SELECTORS.YOTPO_WIDGET)
  const isMobile = widgetEl.classList.contains('yotpo-display-mobile')

  reviewEls.forEach((reviewEl) => {
    const productLinkEl = reviewEl.querySelector(SELECTORS.PRODUCT_LINK)
    const centerPanelEl = reviewEl.querySelector(SELECTORS.CENTER_PANEL)
    const leftPanelEl = reviewEl.querySelector(SELECTORS.LEFT_PANEL)
    const wrapperEl = document.createElement('div')
    const productTitle = productLinkEl.textContent
    const productData = productsData.find((data) => data.title.toLowerCase() === productTitle.toLowerCase())
    
    if (!productData) return

    const targetEl = isMobile ? centerPanelEl : leftPanelEl
    const targetClassName = `${isMobile ? SELECTORS.CENTER_PANEL : SELECTORS.LEFT_PANEL}-wrapper`

    wrapperEl.classList.add(targetClassName.replace('.', ''))
    targetEl.parentNode.insertBefore(wrapperEl, targetEl)
    wrapperEl.appendChild(targetEl)

    const imageEl = document.createElement('img')
    imageEl.src = productData.featured_image
    wrapperEl.appendChild(imageEl)

    imageEl.addEventListener('click', () => productLinkEl.click())
  })

}


const onAddProductImages = () => {
  const intervalTimer = setInterval(() => {
    const targetEl = document.querySelector(SELECTORS.LOADING_PLACEHOLDER)
    if (!targetEl) {
      clearInterval(intervalTimer)
      addProductImages()
    }
  }, 50)
}


const init = () => {
  const dropdownOptionEls = document.querySelectorAll(SELECTORS.DROPDOWN_OPTIONS)
  const paginationItemEls = document.querySelectorAll(SELECTORS.PAGINATION_ITEM)

  dropdownOptionEls.forEach((el) =>
    el.addEventListener('click', () => setTimeout(() => {
      onAddProductImages()
    }, 250))
  )

  paginationItemEls.forEach((el) =>
    el.addEventListener('click', () => setTimeout(() => {
      onAddProductImages()
    }, 250))
  )

  addProductImages()
}

const timer = setInterval(() => {
  const targetEl = document.querySelector(SELECTORS.REVIEW)
  if (targetEl) {
    clearInterval(timer)
    init()
  }
}, 50)